import PropTypes from 'prop-types';
import NwNextSteps from '@nerdwallet/react-next-steps';

/**
 * PropType objects
 */
export const graphqlArticle = PropTypes.object;

export const nextSteps = {
  article: graphqlArticle,
  heading: PropTypes.string,
  // eslint-disable-next-line react/forbid-foreign-prop-types -- directive added automatically by Shepherd migration
  ...NwNextSteps.propTypes,
};

/**
 * PropType definitions
 */

export const nextStepsPropTypes = nextSteps;

const articleConfigPropTypes = {
  articleTypeLabel: PropTypes.string,
  relatedContent: PropTypes.bool,
  hasTableOfContents: PropTypes.bool,
  hasHouseAds: PropTypes.bool,
  hasRelatedLinks: PropTypes.bool,
  hasNextSteps: PropTypes.bool,
};

export const graphqlArticlePropTypes = {
  graphqlArticle,
  slug: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  ...articleConfigPropTypes,
  activeExperiments: PropTypes.arrayOf(
    PropTypes.shape({
      experiment: PropTypes.string,
      variant: PropTypes.string,
    })
  ),
};
